import { Injectable } from "@angular/core";

@Injectable()
export class SharedService {
    public currentLanguage: string = 'en';
}


// WEBPACK FOOTER //
// ./src/app/shared/shared-service.ts